import { ChangeDetectionStrategy, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-toggle',
  imports: [
    ReactiveFormsModule,
  ],
  templateUrl: './toggle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ToggleComponent), multi: true },
  ],
})
export class ToggleComponent implements ControlValueAccessor, OnInit {
  @Input() public id = '';

  public readonly control = new FormControl(false);

  public ngOnInit(): void {
    this.control.valueChanges
      .subscribe(value => this.changeFn(value));
  }

  public registerOnChange(fn: (value: boolean) => void): void {
    this.changeFn = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.touchFn = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }

  public writeValue(selected: boolean): void {
    this.control.setValue(selected, { emitEvent: false });
  }

  private changeFn = (_: boolean | null): void => {};

  private touchFn = (_: boolean): void => {};
}
